const translations = {
  'blog.seo.title': 'Blog sobre la enseñanza del inglés y la vida en Barcelona y Sevilla',
  'blog.seo.description':
    'Publicaciones semanales sobre la vida como docente de inglés en España. Con consejos didácticos, eventos gratuitos y artículos sobre la cultura local.',
};

export default translations;
